module.exports = __webpack_public_path__ + "static/img-oomipood-f53086abe602dde016513ba1396e29ad.png";